import { Banner } from '@tempmee/react';
import { SolidLockClosedIcon } from '@tempmee/react-icons';

export type PaymentLockedBannerContext = 'invite' | 'edit';

const TITLE = 'Add Payment Method to Unlock Invites & Auto-Confirm';

const BODY: Record<PaymentLockedBannerContext, string> = {
  invite:
    'You can still post now and these features will always be free for you, but a payment method is required to confirm and pay candidates.',
  edit: 'You can still make edits now and this feature will always be free for you, but a payment method is required to confirm and pay candidates.',
};

interface IPaymentLockedBannerProps {
  /** Selects the context-specific body copy. */
  context: PaymentLockedBannerContext;
}

/**
 * Non-clickable educational banner shown when an office has no valid payment
 * method. Wraps the Design System `Banner` with a lock icon and context copy.
 */
export const PaymentLockedBanner = ({ context }: IPaymentLockedBannerProps) => (
  <Banner
    variant="brand"
    icon={<SolidLockClosedIcon />}
    title={TITLE}
    description={BODY[context]}
    data-testid="payment-locked-banner"
    data-cy="payment-locked-banner"
  />
);
